<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
        <!-- <div class="modal__logo-title">Seguro Desk</div> -->
      </div>

      <div v-if="this.filesEditMode == 'Calls'" class="modal__main-icon modal__main-icon--calls"></div>
      <div v-if="this.filesEditMode == 'Pendencies'" class="modal__main-icon modal__main-icon--pendencies"></div>
      <div v-if="this.filesEditMode == 'Notes'" class="modal__main-icon modal__main-icon--notes"></div>
      <div v-if="this.filesEditMode == 'Offers'" class="modal__main-icon modal__main-icon--offer"></div>
      <div v-if="this.filesEditMode == 'Leads'" class="modal__main-icon modal__main-icon--notes"></div>

      <div class="modal__close" @click="closeModal()"></div>

      <div class="modal__title">
        {{ filesEditMode }} {{ $t(`allFilesModal.${"files"}`) }}
      </div>
      
      <Loading v-if="filesLoading" />

      <div class="content" v-else>
        <div class="files">
          <div class="files__header">
            <div class="files__label files__label--large name">Name</div>
            <div class="files__label files__label--medium">{{ $t(`allFilesModal.${"view"}`) }}</div>
            <div class="files__label files__label--medium">{{ $t(`allFilesModal.${"date"}`) }}</div>
            <div class="files__label files__label--medium download-label">Download</div>
            <div class="files__label files__label--small">{{ $t(`allFilesModal.${"delete"}`) }}</div>
          </div>
          <div class="files__body">
            <File v-for="file in filesToEdit" :key="file.id" :file="file" :updateFiles="updateFiles" />
          </div>
        </div>
        <DropFile @input="uploadFiles($event)" :deletable="false" :bus="bus" :multiple="filesEditMode === 'Leads'" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import File from "@/components/AccountDetails/File";
import DropFile from "@/components/DropFile";
import Vue from "vue";
import Loading from "@/partials/Loading";
export default {
  name: "AllFilesModal",

  components: {
    File,
    DropFile,
    Loading,
  },

  data() {
    return {
      files: [],
      bus: new Vue(),
      filesLoading: false,


    };
  },

  computed: {
    ...mapGetters([
      "filesEditMode",

      "filesToEdit",
      "filesToEditId",
      "filesToEditOffers",
      "customer",

      'filesFromDashboard',
      'customerFromDashboard',
      'offerToEdit',
    ]),

    isDashboardRoute() {
      return this.$route.path === '/dashboard';
    },
  },

  destroyed() {
    this.closeModal();
  },



  methods: {
    async fetchSalesData() {
      if (this.isDashboardRoute) {
        try {
          await this.$store.dispatch("getSalesDashboard");
        } catch (error) {
          this.$store.commit("setToast", {
            display: true,
            type: "error",
            message: error,
          });
        }
      }
    },

    closeModal() {
      this.$store.commit("setShowFilesEditModal", false);
      this.$store.commit("setFilesToEditId", null);
      this.$store.commit("setFilesToEdit", []);
      this.$store.commit("setFilesToEditOffers", []);
      this.$store.commit("setFilesEditMode", null);

      this.$store.commit("setFilesFromDashboard", false);
      this.$store.commit("setCustomerFromDashboard", null);
    },

    async uploadFiles(event) {
      this.filesLoading = true;
      this.files = event;

      const files = this.files.map((file) => file.file);
      if (this.filesEditMode == 'Pendencies') {
        await this.$store.dispatch("addPendencyFile", {
          pendencyId: this.filesToEditId,
          files,
        });
      } else if (this.filesEditMode == 'Notes') {
        await this.$store.dispatch("addNotesFile", {
          noteId: this.filesToEditId,
          files,
        });
      } else if (this.filesEditMode == 'Calls') {
        await this.$store.dispatch("addCallsFile", {
          callId: this.filesToEditId,
          files,
        });
      } else if (this.filesEditMode == 'Offers') {
        await this.$store.dispatch("addOfferFile", {
          offerId: this.filesToEditId,
          files,
        });
      } else if (this.filesEditMode == 'Leads') {
        await this.$store.dispatch("addLeadFiles", {
          leadId: this.filesToEditId,
          files,
        });
      }
      await this.updateFiles();
      this.bus.$emit("delete");
      this.filesLoading = false;
    },

    async updateFiles() {
      this.filesLoading = true;

      if (this.filesEditMode == 'Pendencies') {
        await this.$store.dispatch("fetchPendencyFiles", this.filesToEditId);
        if (this.filesToEditOffers && this.filesToEditOffers.length) {
          const files = [...this.filesToEdit];
          const refreshedOffers = await Promise.all(
            this.filesToEditOffers.map((offer) => {
              if (!offer || !offer.id) return null;
              return this.$store.dispatch("getSpecificOffer", offer.id);
            })
          );

          refreshedOffers.forEach((offer) => {
            if (!offer) return;
            files.push({
              id: `offer_${offer.id}`,
              name: `offer_${offer.id}.pdf`,
              file_name: `offer_${offer.id}.pdf`,
              created_at: offer.created_at,
              isDownloadable: true,
              offerId: offer.id,
            });
            if (offer.files && Array.isArray(offer.files)) {
              files.push(...offer.files);
            }
          });
          this.$store.commit("setFilesToEdit", files);
        }
        await this.refreshPendencies();

      } else if (this.filesEditMode == 'Notes') {
        await this.$store.dispatch("fetchNoteFiles", this.filesToEditId);
        await this.refreshNotes();

      } else if (this.filesEditMode == 'Calls') {
        await this.$store.dispatch("fetchCallsFiles", this.filesToEditId);
        await this.refreshCalls();

      } else if (this.filesEditMode == 'Offers') {
        this.refreshOffers();
      } else if (this.filesEditMode == 'Leads') {
        await this.$store.dispatch("fetchLeadFiles", this.filesToEditId);
        await this.refreshLeads();
      }

      this.filesLoading = false;
    },

    async refreshPendencies() {
      let customerId = null;
      if (this.filesFromDashboard) {
        customerId = this.customerFromDashboard;
      } else {
        customerId = this.$route.params.id;
      }

      try {
        await this.$store.dispatch("getPendencies", customerId);
      } catch (error) {
        //
        console.log(error)
      }

      await this.fetchSalesData();

      this.$store.commit("setFilesFromDashboard", false);
      this.$store.commit("setCustomerFromDashboard", null);
    },

    async refreshNotes() {
      try {
        await this.$store.dispatch("getNotes", this.$route.params.id);
      } catch (error) {
        //
        console.log(error)
      }
    },

    async refreshCalls() {
      try {
        await this.$store.dispatch("getCalls", this.$route.params.id);
      } catch (error) {
        //
      }
    },

    async refreshOffers() {
      try {
        const customerId = this.$route.params.id;
        await this.$store.dispatch("getSpecificOffer", this.filesToEditId);
        await this.$store.dispatch("getCustomerOffers", customerId);

        const offer = this.$store.getters.offerToEdit;
        if (offer) {
          const files = [];
          files.push({
            id: `offer_${offer.id}`,
            name: `offer_${offer.id}.pdf`,
            file_name: `offer_${offer.id}.pdf`,
            created_at: offer.created_at,
            isDownloadable: true,
            offerId: offer.id,
          });
          if (offer.files && Array.isArray(offer.files)) {
            files.push(...offer.files);
          }
          this.$store.commit("setFilesToEdit", files);
        }
      } catch (error) {
        //
        console.log(error)
      }
    },

    async refreshLeads() {
      try {
        if (this.$route.params.id) {
          await this.$store.dispatch("fetchLeads", this.$route.params.id);
        } else {
          await this.$store.dispatch("fetchLeadCustomers");
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.modal {
  &__title {
    margin: 53px 0 35px 10px;
    font-size: var(--medium);
    font-family: var(--muli-text-semi-bold);
  }

  .modal__title,
  .files__label,
  ::v-deep.file {
    color: var(--text-2);
  }

  .content {
    display: flex;
    align-items: flex-start;
    height: calc(100% - 53px - 35px - 18px);
  }

  .files {
    width: 100%;
    height: 100%;
    margin-right: 20px;
    font-size: var(--x-small);

    &__header {
      border-bottom: 1px solid var(--border-10);
      display: flex;
      padding: 5px 10px;
      margin-bottom: 8px;
    }

    &__body {
      height: calc(100% - 25px - 8px);
      overflow: auto;
      position: relative;
    }

    ::v-deep.file {
      display: flex;
      padding: 20px 10px;
      background: var(--bg-3);
      margin-bottom: 1px;
      position: relative;
      height: 64px;
      max-height: 64px;
      transition: all 0.3s ease;

      &__data {
        &--large {
          color: var(--text-10);
          text-decoration: underline;
        }
      }

      .icon {
        background-position: left;
      }
    }

    &__label,
    ::v-deep.file__data {
      display: flex;
      align-items: center;

      &--large {
        flex: 3;
      }

      &--medium {
        flex: 2;
      }

      &--small {
        flex: 1;
      }
    }
  }
}

.files__label {
  justify-content: center !important;
}

.name {
  justify-content: flex-start !important;
}
</style>